import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ReportListModel} from './models/ReportListModel.model';
import {
  ReportLetterSubstituteParameterModel,
  ReportsLetterSubstituteModel
} from "./models/ReportsLetterSubstituteModel";
import {DataAppointmentModel} from "../../models/appointments/data-appointment.model";
import {ReportModel} from "./models/ReportModel.model";

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(
    private http: HttpClient
  ) {
  }

  getReports(): Observable<ReportListModel[]> {
    return this.http.get<ReportListModel[]>('/api/reports/getReports');
  }

  getFinancialSnapshotHeader(paramsValues: any): Observable<any> {
    const parameters = new HttpParams()
      .set('isProvider', paramsValues.isProvider)
      .set('PracticeId', paramsValues.PracticeId)
      .set('CurrentLocation', paramsValues.CurrentLocation)
      .set('ProviderId', paramsValues.ProviderId);
    return this.http.get<any>('api/reports/getFinancialSnapshotHeader', {params: parameters});
  }

  getFinancialSnapshotDataSource(paramsValues: any, isDaily: boolean): Observable<FinancialSnapshotParams[]> {
    // tslint:disable-next-line:max-line-length
    const parameters = new HttpParams()
      .set('isProvider', paramsValues.isProvider)
      .set('isPractice', paramsValues.isPractice)
      .set('showInactive', paramsValues.showInactive)
      .set('PracticeId', paramsValues.PracticeId)
      .set('ProvidersId', paramsValues.ProvidersId)
      .set('initialDate', paramsValues.initialDate)
      .set('endDate', paramsValues.endDate)
      .set('PracticeLocations', paramsValues.PracticeLocations)
      .set('isDailyReport', isDaily)
      .set('isAsc', paramsValues.isAsc)
      .set('CurrentLocation', paramsValues.CurrentLocation);  
    return this.http.get<FinancialSnapshotParams[]>('api/reports/getFinancialSnapshot', {params: parameters});
  }


  getConceptBrakdownDataSource(paramsValues: any):
    Observable<ConceptBrakedown[]> {
    const parameters = new HttpParams()
      .set('ProviderId', paramsValues.DoctorId)
      .set('LOCID', paramsValues.LOCId)
      .set('ConceptBrakedown', paramsValues.ConceptBrakeDown)
      .set('isProvider', paramsValues.isProvider)
      .set('PracticeId', paramsValues.PracticeId)
      .set('initialDate', paramsValues.initialDate)
      .set('endDate', paramsValues.endDate)
      .set('CurrentLocation', paramsValues.CurrentLocation); 
    return this.http.get<ConceptBrakedown[]>('api/reports/getConceptBrakedown', {params: parameters});
  }


  SaveLetterSubstitutions(letterSubstitute: ReportsLetterSubstituteModel){
    return this.http.post<ReportsLetterSubstituteModel>('api/reports/save-LetterSubstitutions', letterSubstitute);
  }

  saveReportLetterSubstitutionParameter(parameters: ReportLetterSubstituteParameterModel){
    return this.http.post<ReportLetterSubstituteParameterModel>('api/reports/saveReportLetterSubstitutionParameter', parameters);
  }

  saveReportOnlyLetter(report: ReportModel){
    return this.http.post<ReportModel>('api/reports/save-ReportOnlyLetter', report);
  }

  GetLetterSubstitute(reportId: string){
    return this.http.get<ReportsLetterSubstituteModel>(`api/reports/getLetterSubstitute/${reportId}`);
  }


  tryRTB(): Observable<any> {
    return this.http.get<any>('/api/insurance/getRTBResponse');
  }
}

export interface ConceptBrakedown {
  PatientId: string;
  PatientNO: number;
  PatientName: string;
  Tooth: string;
  Code: string;
  ReferringDoctor: string;
  Date: string;
  Amount: number;
  Comments: string;
}

export class FinancialSnapshotParams {
  DoctorID: string;
  FullName: string;
  Address: string;
  LOCID: number;
  // Gross Production
  totalProduction: string;
  adjustedProduction: string;
  mtd: string;
  lastYearMTD: string;
  ytd: string;
  lastYTD: string;
  debitAdjustment: string;
  collections: string;
  cash: string;
  check: string;
  creditCard: string;
  visa: string;
  mastercard: string;
  discovery: string;
  amex: string;
  other: string;
  totalReceipts: string;
  adjustedReceipts: string;
  mtdCollections: string;
  lastYearMTDCollections: string;
  ytdCollections: string;
  lastYTDCollections: string;
  creditAdjustmentsCollections: string;
  ar30Collections: string;
  ar60Collections: string;
  ar90Collections: string;
  arAllCollections: string;
  // Various Statistics
  newWebReferrals: string;
  newNonWebReferrals: string;
  patientsSeen: string;
  daysWorked: string;
  casesStarted: string;
  casesCompleted: string;
  internalEmergencies: string;
  externalEmergencies: string;
  failedCanceledAppointments: string;
  consultsSeen: string;
  avgPICmpltdCases: string;
  treatmentTime: string;
  waitingTime: string;
  // After {End Date}
  patientToBeSeen: string;
}
